import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import {
  UseFilterValuesType,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import { ContentFilterPurposeEnum, ContentFilters, ResourceTypeEnum } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import {
  ContentFilterItemFragment,
  useContentFilterQuery,
} from './graphql/queries/generated/contentFilter';

export type UseContentFilterParams = {
  types?: ResourceTypeEnum[];
  filterPurpose?: ContentFilterPurposeEnum;
  dependentFilters?: Partial<ContentFilters>;
};

const EDGE_KEY = 'contents';

const getContentFilterOption = (content: ContentFilterItemFragment) => ({
  value: content.id,
  label: content.name,
});

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useContentFilterQuery,
    edgeKey: EDGE_KEY,
    variables: {
      filters: {
        ids: value,
        filterPurpose: ContentFilterPurposeEnum.ReportFilter,
        sourceLanguageContent: true,
      },
    },
    getFilterOption: getContentFilterOption,
  });

const useOptionsQuery = ({
  searchText,
  filterPurpose,
  types,
  dependentFilters,
}: UseOptionsQueryParams & UseContentFilterParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useContentFilterQuery,
    edgeKey: EDGE_KEY,
    variables: {
      filters: {
        name: searchText,
        filterPurpose,
        types,
        ...dependentFilters,
        sourceLanguageContent: true,
      },
    },
    getFilterOption: getContentFilterOption,
  });

export const ContentEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useFilterValues,
  useOptionsQuery,
};
